import { apiBaseUrl } from "@/store/api";

const customerProfileBaseUrl = `${apiBaseUrl}/auth/customer-profile`;

export const customerProfileAccountsUrl = `${customerProfileBaseUrl}/customers`;
export const customerProfileSamUrl = (customerId) => `${customerProfileAccountsUrl}/${customerId}`;
export const customerProfileSamRecordUrl = (customerId, type) => `${customerProfileSamUrl(customerId)}/records/${type}`;
export const customerProfileLeadMatchUrl = (leadId) => `${customerProfileBaseUrl}/leads/${leadId}/match`;
export const customerProfileLeadConvertUrl = (leadId) => `${customerProfileBaseUrl}/leads/${leadId}/convert`;
